export const PROJECT_STATUSES = [
  "OPEN",
  "SELF_NOMINATED",
  "NOMINATED",
  "SUBMITTED_TO_AWS",
  "INTERVIEW",
  "ACCEPTED",
  "DECLINED",
  "CLOSED",
  "EXPIRED",
] as const;

export const PROJECT_STATUS_OPTIONS = PROJECT_STATUSES;

export type ProjectStatus = typeof PROJECT_STATUSES[number];
